import MessageForm from "pages/ManagementPage/MessageForm/MessageForm";

export default MessageForm;
